import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { Avatar, Box, Collapse, Grid, LinearProgress } from "@material-ui/core";
import { ExpandLess, ExpandMore, StarBorder } from "@material-ui/icons";
import { useLocation, useRouteMatch } from "react-router-dom";
import ListItemLink from "../ListItemLink";
import apiHelper from "../../util/ApiHelper";
import { useLoading } from "../../util/LoadingProvider";
import { PermissionContext, Roles } from "../../util/PermissionProvider";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    background: theme.palette.primary.light,
    color: theme.palette.primary.contrastTextLight,
  },
  drawerContainer: {
    overflow: "auto",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(4, 6),
    background: "#E5E5E5",
    height: "100%",
  },
  nested: {
    background: theme.palette.primary.main,
    color: "rgba(255, 255, 255, 0.5)",
    "&.active": {
      color: "#FFFFFF",
    },
  },
  systemSelector: {
    background: "#111111",
    borderBottom: "1px solid rgba(159, 163, 168, 0.5)",
    "&:hover": {
      background: "#111111",
    },
  },
  logout: {
    cursor: "pointer",
  },
}));

const hkiffIcon = <img src="/images/hkiff_logo.svg" alt="" />;
const hkiffActiveIcon = <img src="/images/hkiff_active_logo.png" alt="" />;
const starIcon = <StarBorder style={{ color: "#BCBCBC" }} />;

const avalSystems = [
  {
    systemName: "CineFan", path: "cinefan",
    requiredRoles: [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
    icon: hkiffIcon, activeIcon: hkiffActiveIcon,
  },
  {
    systemName: "HKIFF", path: "hkiff",
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER, Roles.HKIFF_MA_EDITOR],
    icon: hkiffIcon, activeIcon: hkiffActiveIcon,
  },
  {
    systemName: "HKIFF APP", path: "hkiff-app",
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER, Roles.HKIFF_MA_EDITOR],
    icon: hkiffIcon, activeIcon: hkiffActiveIcon,
  },
  {
    systemName: "Cineclub", path: "cineclub",
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    icon: hkiffIcon, activeIcon: hkiffActiveIcon,
  },
  {
    systemName: "Walk-in", path: "walk-in",
    requiredRoles: [Roles.SUPERADMIN, Roles.CINECLUB_WI_EDITOR],
    icon: hkiffIcon, activeIcon: hkiffActiveIcon,
  },
  {
    systemName: "HKNT", path: "hknt",
    requiredRoles: [Roles.SUPERADMIN, Roles.HKNT_EDITOR, Roles.HKNT_VIEWER],
    icon: hkiffIcon, activeIcon: hkiffActiveIcon,
  },
  {
    systemName: "HAF", path: "haf",
    requiredRoles: [Roles.SUPERADMIN],
    icon: starIcon, activeIcon: starIcon,
  },
  {
    systemName: "Filmart", path: "filmart",
    requiredRoles: [Roles.SUPERADMIN],
    icon: starIcon, activeIcon: starIcon,
  },
];

export default function Layout(props) {
  const { children, menuObj = [], hideDrawer = false } = props;
  const { userPermissions } = useContext(PermissionContext);
  const history = useHistory();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [admin, setAdminInfo] = React.useState(null);
  const { loading } = useLoading();

  const match = useRouteMatch("/:system");
  const location = useLocation();

  console.log(location.pathname);

  const handleClick = React.useCallback(
    (key) => () => {
      let newObj = Object.assign({}, open);
      newObj[`${key}`] = newObj[`${key}`] ? !newObj[`${key}`] : true;
      setOpen(newObj);
    },
    [open]
  );

  useEffect(() => {
    if (
      sessionStorage.getItem("adminInfo") &&
      sessionStorage.getItem("adminInfo") !== "undefined"
    ) {
      setAdminInfo(JSON.parse(sessionStorage.getItem("adminInfo")));
    } else {
      (async () => {
        apiHelper.adminInfo().then((response) => {
          sessionStorage.setItem("adminInfo", JSON.stringify(response.data));
          setAdminInfo(response.data);
        });
      })();
    }
  }, []);

  useEffect(() => {
    console.log("userPermissions", userPermissions);
  }, [userPermissions]);

  const activeSystem = React.useMemo(
    () =>
      avalSystems.filter((system) => system.path === match.params.system)[0],
    [match.params.system]
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Grid
            justify="space-between" // Add it here :)
            container
            spacing={24}
            alignItems="center"
          >
            <Grid item>
              <Typography variant="h6" noWrap>
                HKIFF Master CMS
              </Typography>
            </Grid>

            <Grid item>
              <div
                className={classes.logout}
                onClick={async () => {
                  await apiHelper.adminLogout();
                  sessionStorage.removeItem("adminInfo")
                  history.push("/login");
                }}
              >
                Logout
              </div>
            </Grid>

            {admin && admin.name && (
              <Grid item>
                <Box component="div" display="inline-block" m={1}>
                  {admin.name}
                </Box>
                <Box component="div" display="inline-block" m={1}>
                  <Avatar>{admin.name.charAt(0).toUpperCase()}</Avatar>
                </Box>
              </Grid>
            )}
          </Grid>
        </Toolbar>
        {loading && <LinearProgress />}
      </AppBar>
      {!hideDrawer && (
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Toolbar />
          <div className={classes.drawerContainer}>
            <List disablePadding>
              <ListItem
                button
                onClick={handleClick("system")}
                className={classes.systemSelector}
              >
                <ListItemIcon>
                  <img
                    src={"/images/hkiff_active_logo.png"}
                    alt={activeSystem.systemName}
                  />
                </ListItemIcon>
                <ListItemText primary={activeSystem.systemName} />
                {open.system ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open.system} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {avalSystems
                    .filter((s) =>
                      userPermissions &&
                      userPermissions.some((p) => s.requiredRoles.includes(p))
                    )
                    .map((s) => (
                      <ListItemLink
                        key={s.path}
                        button
                        className={classes.nested}
                        primary={s.systemName}
                        to={`/${s.path}`}
                        icon={s.icon}
                        activeIcon={s.activeIcon}
                        isActive={activeSystem.systemName === s.systemName}
                        onClick={handleClick("system")}
                      />
                    ))}
                </List>
              </Collapse>
              <Divider />
              {menuObj.map((menu) => {
                switch (true) {
                  case menu.divider === true:
                    return <Divider />;
                  case menu.children?.length > 0:
                    return (
                      userPermissions.length > 0 &&
                      userPermissions.some(
                        (p) =>
                          menu.requiredRoles && menu.requiredRoles.includes(p)
                      ) && (
                        <div className={classes.drawerContainer}>
                          <List disablePadding>
                            <ListItemLink
                              primary={menu.name}
                              to={menu.path}
                              onClick={handleClick(menu.key)}
                              icon={menu.icon}
                            ></ListItemLink>
                            <Collapse
                              in={location.pathname.match(
                                menu.children.map((child) => child.path).join("|")
                              )}
                              timeout="auto"
                              unmountOnExit
                            >
                              {menu.children.map((child) => (
                                <ListItemLink
                                  className={classes.nested}
                                  primary={child.name}
                                  to={child.path}
                                  isChild={true}
                                />
                              ))}
                            </Collapse>
                          </List>
                        </div>
                      )
                    );
                  case !menu.children && !!menu.path && !!menu.name:
                    return (
                      userPermissions.length > 0 &&
                      userPermissions.some(
                        (p) =>
                          menu.requiredRoles && menu.requiredRoles.includes(p)
                      ) && (
                        <ListItemLink
                          primary={menu.name}
                          to={menu.path}
                          icon={menu.icon}
                          isChild={true}
                        />
                      )
                    );
                  case !menu.children && !menu.path && !!menu.name:
                    return (
                      userPermissions.length > 0 &&
                      userPermissions.some(
                        (p) =>
                          menu.requiredRoles && menu.requiredRoles.includes(p)
                      ) && (
                        <ListItem>
                          <ListItemText primary={menu.name} />
                        </ListItem>
                      )
                    );
                  default:
                    return null;
                }
              })}
            </List>
          </div>
        </Drawer>
      )}
      <main className={classes.content}>
        <Toolbar />
        {children}
      </main>
    </div>
  );
}
